import Grid from '@mui/material/Grid';
import Form from 'components/form';
import Input from 'components/form/TextInput';
import React from 'react';
import { useForm } from './Form';
const { FormItem } = Form;

const Address = ({ id, required }) => {
  const { getFieldDecorator } = useForm();

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FormItem>
            {getFieldDecorator(`${id}.address1`, {
              rules: [
                { required, message: 'Required' },
                { max: 75, message: 'Max 75 characters' },
              ],
            })(<Input fullWidth margin="none" placeholder="Address line 1" />)}
          </FormItem>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormItem>
            {getFieldDecorator(`${id}.city`, {
              rules: [
                { required, message: 'Required' },
                { max: 20, message: 'Max 20 characters' },
              ],
            })(<Input fullWidth margin="none" placeholder="City" />)}
          </FormItem>
        </Grid>
        <Grid item xs={6} md={3}>
          <FormItem>
            {getFieldDecorator(`${id}.state`, {
              rules: [
                { required, message: 'Required' },
                { max: 15, message: 'Max 15 characters' },
              ],
            })(<Input margin="none" placeholder="State" />)}
          </FormItem>
        </Grid>
        <Grid item xs={6} md={3}>
          <FormItem>
            {getFieldDecorator(`${id}.zip`, {
              rules: [
                { required, message: 'Required' },
                { max: 10, message: 'Max 10 characters' },
              ],
            })(<Input margin="none" placeholder="Postal Code" />)}
          </FormItem>
        </Grid>
      </Grid>
    </>
  );
};

export default Address;
